"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridPlugin = void 0;
var BindingParser_1 = require("./BindingParser");
var Display_1 = require("./Display");
var DisplayNew_1 = require("./DisplayNew");
var index_1 = require("../../src/index");
var faTh = __importStar(require("@fortawesome/free-solid-svg-icons/faTh"));
var TableXResults_1 = require("../TableXResults");
var I18n_1 = require("./I18n");
var GridPlugin = /** @class */ (function () {
    function GridPlugin(yasr) {
        this.parserBinding = new BindingParser_1.BindingParser();
        this.displayBoxHtml = new Display_1.DisplayBoxHtml();
        this.displayBoxHtmlNew = new DisplayNew_1.DisplayBoxHtmlNew();
        this.priority = 10;
        this.label = "Grid";
        this.yasr = yasr;
        this.config = GridPlugin.defaults;
    }
    GridPlugin.prototype.loadTranslations = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, I18n_1.I18n.init(lang)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GridPlugin.prototype.getTranslation = function (key) {
        return I18n_1.I18n.labels ? I18n_1.I18n.labels[key] || key : key;
    };
    GridPlugin.prototype.download = function (filename) {
        var _this = this;
        return {
            getData: function () { var _a; return ((_a = _this.yasr.results) === null || _a === void 0 ? void 0 : _a.asCsv()) || ""; },
            contentType: "text/csv",
            title: this.getTranslation("Download result"),
            filename: "".concat(filename || "queryResults", ".csv"),
        };
    };
    GridPlugin.prototype.getIcon = function () {
        return (0, index_1.drawSvgStringAsElement)((0, index_1.drawFontAwesomeIconAsSvg)(faTh));
    };
    GridPlugin.prototype.draw = function (PersistentConfig) {
        // init labels
        this.loadTranslations(this.config.lang);
        var results = new TableXResults_1.TableXResults(this.yasr.results);
        var bindings = results.getBindings();
        console.log(bindings);
        if (this.query) {
            var resultBoxes = this.parserBinding.extractResultData(bindings, this.query, this.queryConfiguration);
            /*
            this.displayBoxHtml.displayResultBoxes(
              0,
              resultBoxes,
              this.yasr.resultsEl,
              I18n.labels
            );*/
            this.displayBoxHtmlNew.displayResultBoxes(0, resultBoxes, this.yasr.resultsEl, I18n_1.I18n.labels);
        }
    };
    /*
    public canHandleResults1(): boolean {
      if (!this.query || !this.queryConfiguration) {
        return false;
      }
  
      for (const variable of this.query.variables) {
        if (
          variable["expression"] &&
          typeof variable["expression"] === "object"
        ) {
          return false;
        }
      }
  
      const bindings = this.yasr.results?.getBindings();
  
      if (!bindings) return false;
  
      for (const bindingSet of bindings) {
        for (const value of Object.values(bindingSet)) {
          if (
            typeof value === "object" &&
            value !== null &&
            (value as { type: string }).type === "uri"
          ) {
            return true;
          }
        }
      }
  
      return false;
    }
  */
    GridPlugin.prototype.canHandleResults = function () {
        var _a, _b, _c, _d;
        if (!this.query || !this.queryConfiguration) {
            return false;
        }
        // Vérification si le sujet 's' de la première branche existe dans les variables de la requête
        var firstBranchSubject = (_c = (_b = (_a = this.query.branches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.line) === null || _c === void 0 ? void 0 : _c.s;
        var variableValues = this.query.variables.map(function (v) { return v.value; });
        if (!firstBranchSubject || !variableValues.includes(firstBranchSubject)) {
            return false;
        }
        for (var _i = 0, _e = this.query.variables; _i < _e.length; _i++) {
            var variable = _e[_i];
            if (variable["expression"] &&
                typeof variable["expression"] === "object") {
                return false;
            }
        }
        var bindings = (_d = this.yasr.results) === null || _d === void 0 ? void 0 : _d.getBindings();
        if (!bindings)
            return false;
        for (var _f = 0, bindings_1 = bindings; _f < bindings_1.length; _f++) {
            var bindingSet = bindings_1[_f];
            for (var _g = 0, _h = Object.values(bindingSet); _g < _h.length; _g++) {
                var value = _h[_g];
                if (typeof value === "object" &&
                    value !== null &&
                    value.type === "uri") {
                    return true;
                }
            }
        }
        return false;
    };
    GridPlugin.prototype.notifyQuery = function (sparnaturalQuery) {
        this.query = sparnaturalQuery;
    };
    GridPlugin.prototype.notifyConfiguration = function (specProvider) {
        this.queryConfiguration = specProvider;
    };
    GridPlugin.defaults = {
        lang: "en",
    };
    return GridPlugin;
}());
exports.GridPlugin = GridPlugin;
